export default __webpack_public_path__ + "../staticImages/product_contained_in_set.svg";